import { render } from "./Recap.vue?vue&type=template&id=4a4b1b89"
import script from "./Recap.vue?vue&type=script&setup=true&lang=js"
export * from "./Recap.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/html/lasource-2023/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/cartes-cadeaux/pages/Recap.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a4b1b89"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a4b1b89', __exports__)) {
    console.log('reload')
    api.reload('4a4b1b89', __exports__)
  }
  
  module.hot.accept("./Recap.vue?vue&type=template&id=4a4b1b89", () => {
    console.log('re-render')
    api.rerender('4a4b1b89', render)
  })

}


export default __exports__